import { enUS, uk } from 'date-fns/locale'
import { Locale } from 'date-fns'

import { Language } from 'src/types/enums'

export const localeMap: Record<Language, Locale> = {
  [Language.EN]: enUS,
  [Language.UA]: uk,
}
